<template>
    <div style="margin-top:20px;">
        <b-spinner variant="primary" class="spinStyle" v-show="showSpin" label="Text Centered"></b-spinner>
        <b-tabs content-class='mt-3' v-model="tabIndex">
            <b-tab title="个人信息管理">
                <MemberInfo ref="memberInfo" />
            </b-tab>
            <b-tab title="通知" class="dataTable">
                <OrderNotice ref="orderNotice" />
            </b-tab>
            <b-tab title="收货地址管理" class="dataTable">
                <UserAdress ref="userAdress" />
            </b-tab>
            <b-tab title="往来账目">
                <div class="d-flex " style="margin-bottom:10px;">
                    <DatePicker type="daterange" v-model="fundRecordTab.selectDates" transfer placement="bottom-end"
                        placeholder="选择下单时间" style="width: 200px" @on-change="onDateChange"></DatePicker>
                    <b-input-group style="width:200px;margin-left:10px;">
                        <b-form-input size="sm" v-model="fundRecordTab.keyword" placeholder="输入关联定单号"></b-form-input>
                        <b-input-group-append>
                            <b-button size="sm" v-on:click="onSearchTransaction()">查询</b-button>
                        </b-input-group-append>
                    </b-input-group>
                    <b-button size="sm" variant="success" style="margin-left:10px" @click="onExport()">
                        导出
                    </b-button>
                </div>
                <div class="dataTable">
                    <b-table id="fund-table" :fields="fundRecordTab.fundRecordFields"
                        :items="fundRecordTab.fundRecordList" small bordered hover show-empty empty-text="没有找到匹配的记录"
                        :busy="fundRecordTab.isTableBusy" caption-top>
                        <template slot="table-caption">

                        </template>
                        <template v-slot:cell(memberFundRecordBalance)="data">
                            {{getNumberThousandString(getNumberFloorDecimal(data.item.memberFundRecordBalance),'0.00')  }}
                        </template>
                        <template v-slot:cell(memberFundRecordInFlow)="data">
                            {{getNumberThousandString(data.item.memberFundRecordInFlow,'0.00')  }}
                        </template>
                        <template v-slot:cell(memberFundRecordConsume)="data">
                            {{getNumberThousandString(data.item.memberFundRecordConsume,'0.00')  }}
                        </template>
                        <template v-slot:cell(memberFundRecordDepositInFlow)="data">
                            {{getNumberThousandString(data.item.memberFundRecordDepositInFlow,'0.00')  }}
                        </template>
                        <template v-slot:cell(memberFundRecordDepositConsume)="data">
                            {{getNumberThousandString(data.item.memberFundRecordDepositConsume,'0.00')  }}
                        </template>
                        <template v-slot:cell(memberFundRecordDepositBalance)="data">
                            {{getNumberThousandString(data.item.memberFundRecordDepositBalance,'0.00')  }}
                        </template>
                        <div slot="table-busy" class="text-center text-info my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>加载中...</strong>
                        </div>
                        <template v-slot:cell(memberFundRecordCreateAt)="row">
                            <span>{{formatDateTimeString(row.item.memberFundRecordCreateAt)}}</span>
                        </template>
                    </b-table>
                </div>

                <div class="pageControl">
                    <b-pagination v-model="fundRecordTab.fundSearch.limit.conditions.pageStart" style="margin-top:20px;"
                        :total-rows="fundRecordTab.fundSearch.limit.conditions.total"
                        :per-page="fundRecordTab.fundSearch.limit.conditions.pageLength" align="center" size="sm"
                        ellipsis-text="..." first-text="首页" prev-text="上一页" next-text="下一页" last-text="尾页" limit="10"
                        @change="onFundRecordPageChange"></b-pagination>
                </div>
            </b-tab>
            <b-tab title="投诉建议" class="dataTable">
                <b-table id="suggestion-table" :fields="suggestionTab.suggestionFields"
                    :items="suggestionTab.suggestionList" small bordered hover show-empty empty-text="没有找到匹配的记录"
                    caption-top :busy="suggestionTab.isTableBusy">
                    <template slot="table-caption">
                        <b-button style="float:right;" size="sm" variant="success" v-on:click="onAddSuggestion()">
                            新增投诉
                        </b-button>
                    </template>
                    <div slot="table-busy" class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>加载中...</strong>
                    </div>
                    <template v-slot:cell(suggestionCreatedAt)="row">
                        <span>{{formatDateTimeString(row.item.suggestionCreatedAt)}}</span>
                    </template>
                    <template v-slot:cell(suggestionRepliedAt)="row">
                        <span>{{formatDateTimeString(row.item.suggestionRepliedAt)}}</span>
                    </template>
                    <template v-slot:cell(suggestionStatus)="row">
                        <span v-if="row.item.suggestionStatus === 0" style="color: seagreen;">已发起</span>
                        <span v-else-if="row.item.suggestionStatus === 1" style="color:red;">已回复</span>
                        <span v-else-if="row.item.suggestionStatus === -1">已撤回</span>
                        <span v-else>未知</span>
                    </template>
                    <template v-slot:cell(actionButton)="row">
                        <a href="#" v-on:click="onModifySuggestion(row)">编辑</a>
                        <!--/ <a href="#"
                            v-on:click="onWithDrewSuggestion(row)">撤回</a> -->
                    </template>
                </b-table>
                <div class="pageControl">
                    <b-pagination v-model="suggestionTab.suggestionSearch.limit.conditions.pageStart"
                        style="margin-top:20px;" :total-rows="suggestionTab.suggestionSearch.limit.conditions.total"
                        :per-page="suggestionTab.suggestionSearch.limit.conditions.pageLength" align="center" size="sm"
                        ellipsis-text="..." first-text="首页" prev-text="上一页" next-text="下一页" last-text="尾页" limit="10"
                        @change="onsuggestionPageChange"></b-pagination>
                </div>
            </b-tab>
            <!-- <b-tab title="余额提现单" class="dataTable">
                <RefundList ref="refundList" />
            </b-tab> -->
            <b-tab title="售后列表">
                <OrderComplaint ref="orderComplaint" />
            </b-tab>
            <b-tab title="物流信息" class="dataTable">
                <LogisticsList ref="logisticsList" />
            </b-tab>
            <b-tab title="发票管理">
                <Invoice ref="invoice" />
            </b-tab>
        </b-tabs>

        <!-- 投诉建议 -->
        <b-modal id="suggestionTab.suggestionModel" v-model="suggestionTab.suggestionModel.show"
            :title="suggestionTab.suggestionModel.title" no-close-on-backdrop>
            <b-row align-v="center">
                <b-col lg="12">
                    <b-form>
                        <b-form-group label="内容:" label-cols-lg="2" label-align-lg="right" label-size="sm">
                            <b-form-textarea v-model="suggestionTab.suggestionModel.suggestionDetail"
                                placeholder="请输入内容" required size="sm" rows="3" max-rows="6"></b-form-textarea>
                        </b-form-group>
                        <b-form-group label="相关图片:" label-cols-lg="2" label-align-lg="right" label-size="sm">
                            <b-form-file @input="onSelectFile" accept="image/*" size="sm" placeholder=""
                                browse-text="选择图片"></b-form-file>
                        </b-form-group>
                        <div style="margin-bottom:20px;">
                            <b-img v-if="suggestionTab.suggestionModel.tempImagePath" style="width:50%" center
                                :src="suggestionTab.suggestionModel.tempImagePath"></b-img>
                        </div>
                        <b-form-group v-if="suggestionTab.suggestionModel.suggestionStatus === 1" label="回复内容:"
                            label-cols-lg="2" label-align-lg="right" label-size="sm">
                            <b-form-textarea v-model="suggestionTab.suggestionModel.suggestionReplayDetail" readonly
                                size="sm" rows="3" max-rows="6"></b-form-textarea>
                        </b-form-group>
                        <b-form-group v-if="suggestionTab.suggestionModel.suggestionStatus === 1" label="回复人:"
                            label-cols-lg="2" label-align-lg="right" label-size="sm">
                            <b-form-input v-model="suggestionTab.suggestionModel.suggestionReplyPersonName" size="sm"
                                readonly></b-form-input>
                        </b-form-group>

                    </b-form>
                </b-col>
            </b-row>

            <template slot="modal-footer">
                <b-button size="sm" variant="success" @click="SaveSuggestionInfo()">
                    <b-spinner small v-if="suggestionTab.modifySuggestionBusySpin"></b-spinner>
                    提交
                </b-button>
                <b-button size="sm" variant="danger" @click="suggestionTab.suggestionModel.show = false">
                    取消
                </b-button>
            </template>
        </b-modal>

    </div>

</template>

<script>
import api from '@/api/api';
import axios from 'axios';
import HttpRequest from '@/libs/axios';
import search from '@/libs/search';
import { formatDateTimeString, numberToFixed ,getNumberThousandString,getNumberFloorDecimal} from "@/libs/utils";
import RefundList from '../refund/refund-list.vue';
import OrderNotice  from './order-notice';
import LogisticsList  from './logistics-list.vue';
import MemberInfo from './member-info.vue'
import OrderComplaint from '../order-complaint/order-complaint.vue'
import UserAdress from './user-address.vue'
import Invoice from './invoice.vue'
import "@/style/global.css";
export default {
    name: "PersonInfo",
    components: {
        RefundList,
		OrderNotice,
		LogisticsList,
		MemberInfo,
		OrderComplaint,
		UserAdress,
		Invoice
    },
    data() {
        return {
            fundRecordTab: {
                fundRecordFields: [
                    { key: 'memberFundRecordCreateAt', label: '时间', excel: true },
                    { key: 'memberFundRecordRelateOrderType', label: '类型', excel: true },
                    { key: 'memberFundRecordOperatorName', label: '经办', excel: true },
                    { key: 'memberFundRecordBalance', label: '账户金额', excel: true },
                    { key: 'memberFundRecordInFlow', label: '金额收入', excel: true },
                    { key: 'memberFundRecordConsume', label: '金额支出', excel: true },         
                    { key: 'memberFundRecordDepositInFlow', label: '定金收入', excel: true },
                    { key: 'memberFundRecordDepositConsume', label: '定金支出', excel: true },
                    { key: 'memberFundRecordDepositBalance', label: '定金金额', excel: true },
                    { key: 'memberFundRecordRemark', label: '备注', excel: true }
                ],
                fundRecordList: [],
                isTableBusy: false,
                fundSearch: search.getSearchParams(),
                keyword: '',
                selectDates: []
            },
            suggestionTab: {
                suggestionFields: [
                    { key: 'suggestionDetail', label: '投诉建议内容' },
                    { key: 'suggestionStatus', label: '状态' },
                    { key: 'suggestionRepliedAt', label: '回复时间' },
                    { key: 'suggestionReplyPersonName', label: '回复人' },
                    { key: 'suggestionReplayDetail', label: '回复内容' },
                    { key: 'suggestionCreatedAt', label: '发起时间' },
                    { key: 'actionButton', label: '操作' }
                ],
                suggestionList: [],
                isTableBusy: false,
                suggestionSearch: search.getSearchParams(),
                suggestionModel: {
                    show: false,
                    title: '',
                    formEditMode: '',
                    suggestionUuid: '',
                    suggestionDetail: '',
                    suggestionImages: '',
                    tempImagePath: '',
                    suggestionCreatorUuid: '',
                    suggestionCreator: '',
                    suggestionStatus: '',
                    suggestionCreatedAt: '',
                    suggestionReplyPersonUuid: '',
                    suggestionReplyPersonName: '',
                    suggestionReplayDetail: '',
                    suggestionRepliedAt: ''
                },
                modifySuggestionBusySpin: false
            },
            showSpin: false,
            regionList: [],
            timer: 60,
            smsTimer: null,
            smsButtonText: "获取验证码"
        };
    },
    created() {
        let index = this.$route.query.tabIndex;
        this.tabIndex = index ? parseInt(index) : 0;
    },
    mounted() {
        if (!this.checkMemberLogin()) {
        	this.$router.push({
        		name: 'MemberLogin'
        	});
        	return;
        };
        this.getAllRegionList();
        this.getMemberFundRecord();
        this.getSuggestionList();
    },
    beforeDestroy() {
        clearInterval(this.smsTimer);
        this.smsTimer = null;
    },
    methods: {
        formatDateTimeString,
        getNumberFloorDecimal,
        numberToFixed,
        getNumberThousandString,
        formatManagerText(manager) {
            return manager.mainCateName + '-' + manager.subCateName + '-' + manager.manageInfo;
        },
        onManagerSelectChange(value, data) {
            if (data.length === 3) {
                this.onAddManager(data);
            }
        },
        getAllRegionList(){
            api.webGetAllRegion().then(res => {
                if (res.code === 0) {
                    this.regionList = res.data.allRegions;
                    this.provinceList = this.regionList.filter(e => {
                        return e.regionType === 1;
                    });
                    this.cityList = this.regionList.filter(e => {
                        return e.regionType === 2;
                    });
                    this.distList = this.regionList.filter(e => {
                        return e.regionType === 3;
                    });
                }
            });
        },
        getReginNameByUuid(uuid) {
            let region = this.regionList.find(e => {
                return e.regionUuid === uuid;
            });

            if (region) {
                return region.regionName;
            }
            else {
                return '';
            }
        },
        onSelectFile(file) {
            let param = new FormData(); // 创建form对象
            param.append('file', file, file.name); // 通过append向form对象添加数据
            let config = {
                headers: { 'Content-Type': 'multipart/form-data' }
            };
            let that = this;
            axios.post(api.uploadFile2Qiniu, param, config)
                .then(response => {
                    let res = response.data;
                    if (res.code == 0) {
                        let firstFile = res.data.fileList[0];
                        that.suggestionTab.suggestionModel.suggestionImages = JSON.stringify({
                            name: firstFile.fileName,
                            url: firstFile.fileUuid
                        });
                        that.suggestionTab.suggestionModel.tempImagePath = api.fileServer  + firstFile.fileUuid;
                    }
                });
        },
        onAddSuggestion() {
            this.suggestionTab.suggestionModel.title = "投诉建议信息";
            this.suggestionTab.suggestionModel.formEditMode = "CREATE";
            this.suggestionTab.suggestionModel.suggestionDetail = "";
            this.suggestionTab.suggestionModel.suggestionImages = "";
            this.suggestionTab.suggestionModel.tempImagePath = "";
            this.suggestionTab.suggestionModel.show = true;
        },
        onModifySuggestion(row) {
            Object.assign(this.suggestionTab.suggestionModel, row.item);
            if (row.item.suggestionImages) {
                let file = JSON.parse(row.item.suggestionImages);
                this.suggestionTab.suggestionModel.tempImagePath = api.fileServer + file.url;
            }
            else {
                this.suggestionTab.suggestionModel.tempImagePath = '';
            }
            this.suggestionTab.suggestionModel.title = "投诉建议信息";
            this.suggestionTab.suggestionModel.formEditMode = "MODIFY";
            this.suggestionTab.suggestionModel.show = true;
        },
        onWithDrewSuggestion(row) {
            this.$bvModal.msgBoxConfirm('是否确认撤回该投诉建议？', {
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: '是',
                cancelTitle: '否'
            }).then(value => {
                if (value) {
                    api.webWithdrawSuggestion({
                        suggestionUuid: row.item.suggestionUuid
                    }).then(res => {
                        if (res.code === 0) {
                            this.getSuggestionList();
                        }
                    });
                }
            });
        },
        SaveSuggestionInfo() {
            this.suggestionTab.modifySuggestionBusySpin = true;
            api.webSaveSuggestion(this.suggestionTab.suggestionModel).then(res => {
                this.suggestionTab.modifySuggestionBusySpin = false;
                if (res.code === 0) {
                    this.$bvModal.msgBoxOk("操作成功", {
                        title: '提示',
                        buttonSize: 'sm'
                    });
                    this.getSuggestionList();
                    this.suggestionTab.suggestionModel.show = false;
                }
            });
        },
        getSuggestionList() {
            if (this.checkMemberLogin()) {
				this.showSpin = true;
                api.webGetSuggestionList(this.suggestionTab.suggestionSearch).then(res => {
					this.showSpin = false;
                    if (res.code === 0) {
                        this.suggestionTab.suggestionList = res.data.records;
                        search.globalSetFilterRecordCount(this.suggestionTab.suggestionSearch, res.data.filterRecordCount);
                    }
                });
            }
        },
        onsuggestionPageChange(pageNum) {
            search.globalPageOnChange(this.suggestionTab.suggestionSearch, pageNum);
            this.getSuggestionList();
        },
        showInvoiceAccount() {
            this.$refs.invoiceAccountModal.showModal();
        },
        preViewInvoice() {
            this.invoiceModal.loading = true;
            api.webGetInvoice({ deliveryUuidList: this.invoiceModal.invoiceDeliveryUuidList.split(',') }).then(res => {
                if (res.code === 0) {
                    this.invoiceModal.loading = false;
                    this.$refs.invoicePreviewModal.showModal(res.data);
                }
            });

        },
        onDateChange(e) {
            this.fundRecordTab.selectDates = e;
            let field = "memberFundRecordCreateAt";
            search.globalRemoveFilterConditionKey(this.fundRecordTab.fundSearch, field);
            this.fundRecordTab.fundSearch.filters.enable = true;
            this.fundRecordTab.fundSearch.filters.conditions.push({
                name: field,
                type: 'datebetween',
                value: JSON.stringify(e)
            });
            search.globalResetSearch(this.fundRecordTab.fundSearch);
            this.getMemberFundRecord();
        },
        onSearchTransaction() {
            let field = "memberFundRecordRemark";
            search.globalRemoveFilterConditionKey(this.fundRecordTab.fundSearch, field);
            search.globalResetSearch(this.fundRecordTab.fundSearch);
            if (this.fundRecordTab.keyword) {
                this.fundRecordTab.fundSearch.filters.enable = true;
                this.fundRecordTab.fundSearch.filters.conditions.push({
                    name: field,
                    type: 'like',
                    value: this.fundRecordTab.keyword
                });
            }
            this.getMemberFundRecord();
        },
        onExport() {
            const searchCondition = search.deepClone(this.fundRecordTab.fundSearch);
            searchCondition.limit.enable = false;
            searchCondition.excelExport.enable = true;
            searchCondition.excelExport.columns = this.fundRecordTab.fundRecordFields
                .filter(col => col.excel)
                .map(col => {
                    return {
                        key: col.key,
                        title: col.label
                    };
                });

            this.fundRecordTab.isTableBusy = true;
            api.webGetMyFundRecord(searchCondition).then(res => {
                this.fundRecordTab.isTableBusy = false;
                if (res.code === 0) {
                    let url = api.downLoadServer + res.data.exportFileName;
                    this.$downLoadFile(url);
                }
            });
        },
        getMemberFundRecord() {
            if (this.checkMemberLogin()) {
                this.fundRecordTab.isTableBusy = true;
                api.webGetMyFundRecord(this.fundRecordTab.fundSearch).then(res => {
                    this.fundRecordTab.isTableBusy = false;
                    if (res.code === 0) {
                        this.fundRecordTab.fundRecordList = res.data.records;
                        search.globalSetFilterRecordCount(this.fundRecordTab.fundSearch, res.data.filterRecordCount);
                    }
                });
            }
        },
        onFundRecordPageChange(pageNum) {
            search.globalPageOnChange(this.fundRecordTab.fundSearch, pageNum);
            this.getMemberFundRecord();
        }
    }
};
</script>

<style>
.form-row{
	align-items: center !important;
	height: 100rpx !important;
}
.bv-no-focus-ring figure{
	margin: 0 !important;
}

.registerInfo .form-group {
    margin-bottom: 15px;
}

.registerInfo .formSelect {
    width: 32%;
}

.invoiceField {
    height: 40px;
}
/*选项页面样式*/
.nav-tabs{
	background-color: #fafafa !important;
	border-bottom: none !important;
	padding: 5px !important;
	margin-bottom: 10px !important;
}
.nav-tabs .nav-link.active{
	color:#00b151 !important;
	border-bottom: 3px solid #00b151 !important;
	background-color:transparent !important;
	font-weight: 600 !important;
}
.nav-link{
	color: #000000 !important;
}
.nav-link:hover{
	color: #00b151 !important;
}
.nav-tabs .nav-link{border: none !important;}
/*共用表格样式*/
/*收货地址管理-交易明细—投诉建议*/
.dataTable th{
	background-color: #fff;
	white-space: nowrap;
	line-height:40px;
	text-align: center;
	}
.table td a{color: #00b151;}
.d-flex .btn-secondary {
    background-color: #00b151 !important;border-color: #28a745 !important;
}
/*页码样式*/
.page-link{color:#757575 !important;}
 .page-link:hover{color: #00b151 !important;}
 .page-item.active .page-link{color:#fff !important;background-color: #28a745 !important;border-color: #28a745 !important;}
 .pagination-sm .page-link{
 	padding: 5px 12px !important;
 	margin-top: 40px;
 	}
.page-link:focus{box-shadow: none !important;}

/* 生产项目多选框背景色 */
.productType .custom-control-input:checked~.custom-control-label::before{color:#fff !important;background-color:#01B252 !important;border-color: #01B252 !important;}
.productType .custom-checkbox .custom-control-input:checked~.custom-control-label::after{background-color:#01B252 !important;}

/* 个人信息修改提交按钮 */
.person-info-btn .btn-primary {color: #fff;background-color: #01B252;border-color: #01B252;}
.person-info-btn .btn-primary.focus, .person-info-btn .btn-primary:focus{
	background-color: #039f4a;
    border-color: #039f4a;
    box-shadow:none;
}


.person-info-btn .btn-warning {color: #fff;background-color: #e5ad06;border-color: #e5ad06;}
.person-info-btn .btn-warning:not(:disabled):not(.disabled).active, .person-info-btn .btn-warning:not(:disabled):not(.disabled):active, .person-info-btn .show>.btn-warning.dropdown-toggle{color:#fff;}
.person-info-btn .btn-warning.focus, .person-info-btn .btn-warning:focus{
	color:#fff;
	background-color: #d39f06;
    border-color: #d39f06;
    box-shadow:none;
}
.person-info-wrap .registerInfo{border: 1px solid rgba(0,0,0,.125);}
.person-info-wrap .card-header{text-align: center;padding:15px 0px;background-color: rgba(0,0,0,.03);border-bottom: 1px solid rgba(0,0,0,.125);}
.col-form-label-sm{margin-right:10px;}
</style>



// WEBPACK FOOTER //
// src/view/member/person-info.vue